export enum SurfacelogVisualizerMeasurementUnit {
  METERS = 'Meters',
  US_SURVEY_FEET = 'US_Survey_Feet'
}